import React, {Component} from 'react'
import Helmet from "react-helmet";
import Logo from "../../assets/images/mobile-logo.png";
import {Spin, message, Modal,} from "antd";
import {readToken, checkWxSub, handleWxCode} from "../../utills/wechatUtils"
import ajax from "../../api/ajax";
import {baseUrl} from "../../api";
import priceHead from "./images/price_head.png";
import priceMsg from "./images/price_msg.png";
class SubscribePrice extends Component {
    state = {
        loading: false,
        visible: false,
        id: null,//订阅记录id
    };
    doSub = () => {
        const wxToken = readToken();
        let data = new FormData();
        data.append("openid", wxToken.openid);
        data.append("token", wxToken.accessToken);
        data.append("type", "price");
        let result = ajax(baseUrl + "/d/public/subscribe", data, "POST");
        result.then((resp) => {
            if (resp && resp.code === 201) {
                this.setState({visible: true});
            } else if (resp && resp.code === 400) {
                message.error(resp.message);
                this.wxReset();
            }
        }).finally(() => {
            this.getSubList()
        })
    };
    closeMsg = () => {
        this.setState({visible: false})
    };
    doUnSub = () => {
        const wxToken = readToken();
        const data = {openid: wxToken.openid, token: wxToken.accessToken, id: this.state.id};
        let result = ajax(baseUrl + "/d/public/subscribe", data, "DELETE");
        result.then((resp) => {
            if (resp && resp.code === 200) {
                message.info("关闭提醒成功")
            } else {
                message.error(resp.message)
            }
        }).finally(() => {
            this.setState({loading: false,});
            this.getSubList(wxToken)
        })
    };
    getSubList = (wxToken = readToken()) => {
        const data = {openid: wxToken.openid, token: wxToken.accessToken, type: 'price'};
        this.setState({loading: true});
        let result = ajax(baseUrl + "/d/public/subscribes", data);
        result.then((resp) => {
            if (resp && resp.code === 200) {
                if (resp.data.length > 0) {
                    this.setState({id: resp.data[0].id})
                } else {
                    this.setState({id: null})
                }
            }
        }).catch(() => {

        }).finally(() => {
            this.setState({loading: false});
        })
    };

    componentDidMount() {
        handleWxCode(this.props).then((ret) => {
            checkWxSub();
            this.getSubList(ret)
        }).catch((e) => {
            //console.error(e)
        })
    }

    render() {
        const {loading, visible, id} = this.state;
        return (
            <div className='mobile-upload'>
                <Helmet
                    meta={[
                        {name: "viewport", content: "width=device-width,initial-scale=1.0,user-scalable=no"},
                    ]}
                    title="呜呜网"
                />
                <div className='mobile-upload-header'>
                    <img src={Logo} alt="Logo"/>
                </div>
                <div className='subscribe'>
                    <div className='subscribe-title'>报价更新提醒</div>
                    <div style={{margin: '0 auto', width: "fit-content"}}>
                        <img src={priceHead} alt='priceHead' width="100%"/>
                    </div>
                    <Spin size="large" spinning={loading}>
                        {id == null ?
                            <div className='subscribe-box-info'>
                                <div style={{
                                    fontSize: "0.8rem",
                                    padding: 8,
                                    color: "#fff",
                                    backgroundColor: "#1592D5",
                                    border: "1px solid",
                                    width: "fit-content",
                                    margin: "auto"
                                }} onClick={this.doSub}>开启提醒
                                </div>
                            </div> :
                            <div className='subscribe-box-info'>
                                <div style={{
                                    fontSize: "0.8rem",
                                    padding: 8,
                                    color: "#1592D5",
                                    border: "1px solid",
                                    width: "fit-content",
                                    margin: "auto"
                                }} onClick={this.doUnSub}>关闭提醒
                                </div>
                            </div>
                        }
                    </Spin>
                </div>
                <Modal visible={visible}
                       onCancel={this.closeMsg}
                       footer={null}
                       style={{width: 'max-content'}}
                >
                    <div className='subscribe-info-box'>
                        <div align="center">
                            <p><img src={priceMsg} alt='priceMsg'/></p>
                            <p className="subscribe-title" style={{padding: 8, fontSize: "1rem", color: "#1592D5",}}>
                                报价更新提醒<br/>开启成功
                            </p>
                            <p>最新报价将会以公众号形式第一时间推送到您的微信</p>
                            <div style={{
                                fontSize: "0.8rem",
                                padding: 8,
                                color: "#1592D5",
                                border: "1px solid",
                                width: "fit-content",
                                marginTop: "20px"
                            }} onClick={this.closeMsg}>我知道了
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }
}
export default SubscribePrice